import { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import useApp from "../../AppContext";
import "./EntryWithBooking.css";
import { useNavigate } from "react-router-dom";
import NewTabletBooking from "./NewTabletBooking";
import HomeIcon from '@mui/icons-material/Home';
import { t } from "./../../i18n"
function Entry(props) {
    const navigate = useNavigate();
    const app = useApp();
    const [language] = useState(app.sessionToken?.Language);
    const [isHoliday] = useState(false);
    const [saveTriggered, setSaveTriggered] = useState(0);
    const [isFormValid, setIsFormValid] = useState(false);
    return (
        <>
            <div className="container my-5 tablet-container">
                <div className="mb-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <button onClick={() => navigate('/tablet-view')}><HomeIcon fontSize="small" style={{ marginBottom: '5px' }} /> {t("tablet.home", language)}</button>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">{t("tablet.entryWithNoBooking", language)}</li>
                        </ol>
                    </nav>
                </div>
                <h2 className="mb-4">{t("tablet.entryWithNoBooking", language)}</h2>
                <NewTabletBooking
                    saveTriggered={saveTriggered}
                    onValidationChange={setIsFormValid}
                    actions={"NewBoocking"}
                    bookingId={'0'}
                    supplierData={[]}
                    warehouseid={app.sessionToken.WarehouseId}
                    isHoliday={isHoliday}
                    userToken={props.userToken}
                />
            </div>
            <div className="tablet-btn-fixed-bottom">
                <button type="submit" className="btn btn-tablet-color" onClick={() => setSaveTriggered(prev => prev + 1)} disabled={!isFormValid}>
                    {t("common.registration", language)}
                </button>
            </div>
        </>
    );
}

export default Entry;
